import '../configuracoes.css'

import { useState, useEffect } from 'react';

import { servGetGruposPorCPF, servAssociaGrupo, servDesassociaGrupo } from '../../../servicos/servicosEmRotasPrivadas/grupo_usuario';

import minusIcon from '../../../imagens/minus.png'
import plusIcon from '../../../imagens/plus-sign.png'

import toast from 'react-hot-toast';
import BarraBuscaCpf from '../../BarraBuscaCpf';
import TituloSessao from '../../TituloSessao';
import { formatCPF } from '../../../util/utilitarios';
import { toastErrorPydantic } from '../../../util/toast_pydantic';

function AssociaUsuarioGrupo() {

    console.log('### Iniciando ModalAssociaRoleCpf ###');

    const [cpf, setCpf] = useState(null)
    const [grupos, setGrupos] = useState(null)

    useEffect(() => {
        if (cpf) getGruposPorCPF();
    }, [cpf]);

    const getGruposPorCPF = async () => {
        try {
            const gruposDaApi = await toast.promise(
                servGetGruposPorCPF(cpf),
                { loading: 'Buscando permissões associadas ao usuário...' }
            )
            setGrupos(gruposDaApi.data);
        } catch (error) {
            setGrupos(null);
            toastErrorPydantic(error);
        }
    }

    const associaGrupo = async (cpf, grupoId) => {
        try {
            const associao = { cpf: cpf, grupoId: grupoId }
            await toast.promise(
                servAssociaGrupo(associao),
                { loading: 'Associando CPF...' }
            )
            getGruposPorCPF()
        } catch (error) {
            toastErrorPydantic(error);
        }
    }

    const desassociaGrupo = async (grupoUsuarioId, usuarioId) => {
        try {
            await toast.promise(
                servDesassociaGrupo(grupoUsuarioId, usuarioId),
                { loading: 'Desassociando CPF...' }
            )
            getGruposPorCPF()
        } catch (error) {
            toastErrorPydantic(error);
        }
    }

    return (
        <div className="container-configuracoes div-com-borda">
            <strong>
                <p className='m-0 fs-5'>Informe os 11 dígitos do CPF para buscar o usuário</p>
            </strong>
            <BarraBuscaCpf
                cpf={cpf}
                onChange={setCpf}
            />
            {grupos &&
                <div className='d-flex flex-column gap-3'>
                    <div className=''>
                        <p className="fs-5">Grupos Associados</p>

                        {
                            grupos.associados.length < 1
                                ?
                                <p className='m-0'>Não há grupos associados a este usuário</p>
                                :
                                <ul className="list-group">
                                    {grupos.associados.map((grupo) =>
                                        <li key={grupo.grupoId}
                                            className="list-group-item d-flex justify-content-between">{grupo.grupo}
                                            <div className='align-items-center d-flex'>
                                                <img
                                                    className='minusAndPlusIcon'
                                                    style={{ 'width': '1.5em' }}
                                                    alt='icone de diminuicao'
                                                    src={minusIcon}
                                                    onClick={() => desassociaGrupo(grupo.grupoId, grupo.usuarioId)}
                                                />
                                            </div>
                                        </li>
                                    )}
                                </ul>
                        }
                    </div>
                    <div className=''>
                        <p className="fs-5">Associar Grupos</p>

                        {
                            grupos.naoAssociados.length < 1
                                ?
                                <p className='m-0'>Todos os grupos estão associados a este usuário</p>
                                :
                                <ul className="list-group">
                                    {grupos.naoAssociados.map((grupo) =>
                                        <li
                                            key={grupo.id}
                                            className="list-group-item d-flex justify-content-between"
                                        >
                                            <span className="">
                                                {grupo.descricao}
                                            </span>
                                            <div className='align-items-center d-flex'>
                                                <img
                                                    className='minusAndPlusIcon'
                                                    style={{ 'width': '1.5em' }}
                                                    alt='icone de diminuicao'
                                                    src={plusIcon}
                                                    onClick={() => associaGrupo(cpf, grupo.id)}
                                                />
                                            </div>
                                        </li>

                                    )}
                                </ul>
                        }
                    </div>
                </div>
            }
        </div >
    )
}

export default AssociaUsuarioGrupo
